export default __webpack_public_path__ + "static/media/bump.b963b27c.png";